import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.korenet.organization.detail');
import { OnInit, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-korenet-organization-detail',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.korenet.organization.detail/view.scss */
:host {
  display: block;
  width: 100%;
}`],
})
export class PortalKorenetOrganizationDetailComponent implements OnInit {
    @Input() orgId: string = '';

    public org: any = null;
    public researchers: any[] = [];
    public loading: boolean = true;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        if (this.orgId) {
            await this.loadData();
        }
        this.loading = false;
        await this.service.render();
    }

    private async loadData() {
        const [infoRes, researcherRes] = await Promise.all([
            wiz.call("info", { org_id: this.orgId }),
            wiz.call("top_researchers", { org_id: this.orgId, limit: 10 })
        ]);

        if (infoRes.code === 200) {
            this.org = infoRes.data;
        }
        if (researcherRes.code === 200) {
            this.researchers = researcherRes.data.rows || [];
        }
    }

    public goResearcher(id: string) {
        this.service.href(`/researcher/${id}`);
    }

    public getInitial(name: string): string {
        if (!name) return '?';
        return name.charAt(0);
    }
}

export default PortalKorenetOrganizationDetailComponent;